import { ThemeOptions } from '@mui/material';
import { HEADER_HEIGHT } from 'config';

export const componentStyleOverrides: ThemeOptions['components'] = {
  // MuiRadio:{
  //   styleOverrides: {
  //     root: ({ ownerState, theme }) => ({
  //       height: 40,
  //     })
  //   }
  // },
  // MuiButtonGroup: {
  //   styleOverrides: {
  //     root: {
  //       // Your custom styles here
  //       backgroundColor: 'lightblue',
  //       borderRadius: '8px',
  //       height:400
  //     },
  //   },
  // },
  // MuiButtonGroup:{
  //   // defaultProps: {
  //   //   variant: 'outlined'
  //   // },
  //   styleOverrides: {
  //     root: ({ ownerState, theme }) => ({
  //       height: 40,
  //       borderRadius: 40,
  //       fontSize: theme.typography.body1.fontSize,
  //       fontWeight: theme.typography.body1.fontWeight,
  //       lineHeight: theme.typography.body1.lineHeight,
  //       backgroundColor: 'red',
  //     }),

  //   }
  // },
  MuiButtonGroup: {
    // defaultProps: {
    //   variant: 'outlined'
    // },
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        borderRadius: '140px',
        border: '1px solid rgba(0, 0, 0, 0.1)'
      })
    }
  },
  MuiButton: {
    defaultProps: {
      variant: 'contained'
    },
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        height: 36,
        minWidth: 132,
        borderRadius: 8,
        textTransform: 'capitalize',
        fontSize: theme.typography.subtitle1.fontSize,
        fontWeight: theme.typography.subtitle1.fontWeight,
        lineHeight: theme.typography.subtitle1.lineHeight,
        boxShadow: 'none',
        '&:disabled': {
          color: '#fff',
          background: 'linear-gradient(148deg, rgba(46,158,228,0.4) 0%, rgba(131,60,226,0.4) 100%)'
        },
        '&.MuiButtonGroup-grouped': {
          borderRadius: '140px',
          border: '0px solid rgba(0, 0, 0, 0)',
          padding: '7px 30px',
          color: 'rgba(0, 0, 0, 0.6)',
          '&.selected': {
            background: '#F3EBFC',
            color: '#833CE2'
            // border: '1px solid rgba(182, 182, 182, 0.1)'
          }
        },
        ...(ownerState.variant === 'contained' &&
          ownerState.color === 'primary' && {
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            color: '#fff',
            backgroundColor: 'rgb(131, 60, 226)',
            background: `linear-gradient(148deg, #2E9EE4 0%, ${theme.palette.primary.main} 100%)`
          }),
        ...(ownerState.variant === 'contained' &&
          ownerState.color === 'success' && {
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            color: '#fff'
            // backgroundColor: 'rgb(131, 60, 226)',
            // background: `linear-gradient(148deg, #2E9EE4 0%, ${theme.palette.primary.main} 100%)`
          }),
        ...(ownerState.variant === 'contained' &&
          ownerState.color === 'secondary' && {
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            color: '#000',
            backgroundColor: '#DEDEDE;',
            '&:hover': {
              backgroundColor: 'rgba(222, 222, 222, .6)',
              boxShadow: 'none'
            }
            // background: `linear-gradient(148deg, #2E9EE4 0%, ${theme.palette.primary.main} 100%)`
          }),
        ...(ownerState.variant === 'outlined' && {
          borderWidth: '2px',

          '&:hover': {
            borderWidth: '2px'
          }
        }),
        ...(ownerState.variant === 'outlined' &&
          ownerState.color === 'primary' && {
            color: theme.palette.primary.main,
            border: `2px solid transparent`,
            background: `linear-gradient(white, white) padding-box,linear-gradient(148deg, #2E9EE4 0%, ${theme.palette.primary.main} 100%) border-box`,
            '&:hover': {}
          })
      }),
      startIcon: ({ theme, ownerState }) => ({
        ...(ownerState.variant === 'contained' &&
          ownerState.color === 'primary' && {
            '& svg': {
              fill: theme.palette.common.white
            },
            '& svg *': {
              fill: theme.palette.common.white
            }
          })
      }),
      endIcon: ({ theme, ownerState }) => ({
        ...(ownerState.variant === 'contained' &&
          ownerState.color === 'primary' && {
            '& svg': {
              fill: theme.palette.common.white
            },
            '& svg *': {
              fill: theme.palette.common.white
            }
          })
      })
    }
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        borderRadius: 12
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: theme.typography.caption.fontSize,
        fontWeight: theme.typography.caption.fontWeight,
        lineHeight: theme.typography.caption.lineHeight,
        marginLeft: 0
      })
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontWeight: theme.typography.subtitle1.fontWeight,
        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: theme.typography.subtitle1.lineHeight,
        color: theme.palette.common.black
      })
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 8,
        height: 48,
        background: '#F9F9F9',
        transition: theme.transitions.create('background', {
          easing: theme.transitions.easing.easeIn,
          duration: theme.transitions.duration.standard
        }),
        paddingRight: '8px',
        '&:hover': {
          background: 'rgba(190, 190, 190, 0.25)',
          transition: theme.transitions.create('background', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.standard
          })
        }
      }),
      multiline: {
        height: '100%',
        borderRadius: 8
      },
      input: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.lineHeight,
        padding: '14px 12px',
        fontWeight: theme.typography.body1.fontWeight
      })
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: 10,
        lineHeight: '150%',
        color: theme.palette.common.black
      })
    }
  },
  MuiTextField: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: 14,
        lineHeight: '150%',
        color: theme.palette.common.black
      })
    }
  },
  MuiChip: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
        fontWeight: theme.typography.body1.fontWeight,
        lineHeight: theme.typography.body1.lineHeight,
        borderColor: 'rgba(182, 182, 182, 0.30)'
      })
    }
  },
  // MuiListItemText:{
  //   styleOverrides: {
  //     root: ({ theme }) => ({
  //       fontSize : theme.typography.h1.fontSize,
  //       fontWeight : theme.typography.h1.fontWeight,
  //       lineHeight : theme.typography.h1.lineHeight,
  //     })
  //   }
  // },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        // height: 48,
        borderRadius: 8,
        '& .MuiOutlinedInput-notchedOutline': {
          // borderColor: '#E5E5E5'
          borderColor: 'transparent'
        },
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            // borderColor: theme.palette.primary.main
            borderColor: 'transparent'
          }
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
          }
        }
      }),
      multiline: {
        // height: 21 * 4 + (48 - 21)
        height: '100%'
      }
    }
  },
  MuiTabs: {
    styleOverrides: {
      indicator: {
        display: 'none'
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: () => ({
        textTransform: 'none',
        fontSize: '14px',
        '&.Mui-selected': {
          position: 'relative',
          fontSize: '14px',
          '&:after': {
            position: 'absolute',
            width: '35px',
            background: 'linear-gradient(148deg, #2E9EE4 0%, #833CE2 100%)',
            content: '""',
            bottom: 0,
            height: 3,
            left: 0,
            margin: 'auto',
            right: 0,
            borderRadius: 20,
            fontSize: '14px'
          }
        }
      })
    }
  },
  MuiTableCell: {
    styleOverrides: {
      head: () => ({
        '&:not(:first-of-type)': {
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            margin: 'auto',
            left: 0,
            height: '40%',
            bottom: 0,
            borderLeft: '1px solid rgba(0, 0, 0, 0.2)'
          }
        }
      }),
      body: {
        border: 'none'
      }
    }
  },
  MuiTableRow: {
    styleOverrides: {
      hover: () => ({
        '&:hover': {
          backgroundColor: 'rgba(131, 60, 226, 0.08)'
        }
      }),
      root: () => ({
        '&.MuiTableRow-hover': {
          '&:hover': {
            backgroundColor: 'rgba(131, 60, 226, 0.06)'
          }
        }
      })
    }
  },
  MuiToolbar: {
    defaultProps: { variant: 'dense' },
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        height: HEADER_HEIGHT,
        minHeight: HEADER_HEIGHT
      })
    }
  },
  MuiRadio: {
    // defaultProps: { variant: 'dense' },
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        height: 36
      })
    }
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: ({ theme }) => ({
        option: {
          marginLeft: 8,
          marginRight: 8,
          borderRadius: 8
        },
        '&.MuiAutocomplete-popupIndicator': {
          opacity: 1
        },
        '&.MuiAutocomplete-endAdornment': {
          opacity: 1
        }
      })
    }
  },
  MuiPaginationItem: {
    defaultProps: {
      variant: 'outlined'
    },
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        ...(ownerState.variant === 'outlined' &&
          ownerState.color === 'primary' && {
            border: 'none',
            background: '#fff',
            borderRadius: '8px',
            '&.Mui-selected': {
              color: '#fff',
              background: `linear-gradient(148deg, #2E9EE4 0%, ${theme.palette.primary.main} 100%)`,
              border: 'none'
            },
            '&.MuiPaginationItem-previousNext': {
              color: '#833CE2'
            },
            '&.MuiPaginationItem-firstLast': {
              color: '#833CE2'
            }
          })
      })
    }
  },
  MuiSelect: {
    styleOverrides: {}
  },
  MuiCheckbox: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: '#BEBEBE'
      })
    }
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        // padding: '16px 24px'
        '& .MuiDialog-paper': {
          padding: '16px 24px'
        }
      })
    }
  }
};
